import styled from "styled-components";
import { FlexRow } from "styles/layout";
import { Theme } from "theme";
import { LeftBorderAltBackgroundTableCell } from "../styles";

export const CupModeTrackTimesContainer = styled(FlexRow)`
  background: ${Theme.trackTimesAltBackground};
  overflow: auto;
  width: 100%;
  align-items: stretch;
`;

export const CupModeMatchTimesTable = styled.table`
  padding: 0 15px;
  border-spacing: 0;

  td,
  th {
    white-space: nowrap;
  }
`;

export const TrackNameHeader = styled.th`
  font-size: 14pt;
  font-weight: 500;
  padding: 12px;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
`;

export const RoundNameCell = styled(LeftBorderAltBackgroundTableCell)`
  font-size: 11pt;
  text-align: center;
  font-weight: 500;
  padding: 0 8px;
`;

export const RoundStartScoreSpan = styled.div`
  width: 30px;
  text-align: center;
`;

export const RoundDiffSpan = styled.div`
  font-size: 10pt;
  padding-left: 5px;
  width: 25px;
  text-align: left;
`;
